<template>
  <v-card style="width: 75vw; margin: 32px auto">
    <div class="d-flex align-start" style="padding: 24px;">
      <h2 class="mr-auto">Statistics</h2>
      <Tooltip :message="tooltipMessage"></Tooltip>
    </div>
    <div class="align-center mx-5"
      style="display: grid; grid-template-columns:25% 25% 15% 32%; gap: 12px; padding-bottom: 24px;">
      <div>
        <v-menu v-model="menustart" :close-on-content-click="false" transition="scale-transition" offset-y
          min-width="auto">
          <template v-slot:activator="{ props }">
            <v-text-field v-model="displaydatestart" hide-details label="Start date" class="ml-4" readonly
              v-bind="props"></v-text-field>
          </template>
          <v-date-picker v-model="datestart" @update:model-value="selectdate">
          </v-date-picker>
        </v-menu>
      </div>
      <div>
        <v-menu v-model="menuend" :close-on-content-click="false" transition="scale-transition" offset-y
          min-width="auto">
          <template v-slot:activator="{ props }">
            <v-text-field v-model="displaydateend" hide-details label="End date" readonly v-bind="props"></v-text-field>
          </template>
          <v-date-picker v-model="dateend" @update:model-value="selectdate"></v-date-picker>
        </v-menu>
      </div>
      <div style="display: flex;">
        <v-checkbox v-model="showNotRegistered" @update:model-value="updatereport(this.workspaceid)"
          color="green-lighten-1" hide-details></v-checkbox>
        <p style="margin: auto 0px;">Show not registered</p>
      </div>
      <div class="d-flex" style="width: 100%; gap: 12px;">
        <v-btn color="white" @click="clearfilter()" width="30px">Clear</v-btn>
        <v-btn v-if="userAllowedToGeneratePDFReports" color="white" @click="generatePDF()">Generate Report<AlertDialog ref="alertDialog"/></v-btn>
      </div>
      <div>
      </div>
    </div>
    <v-data-table dense :headers="headers" :items="statisticsResult" :sort-by.sync="sortOptions.sortBy"
      :sort-desc.sync="sortOptions.sortDesc" :options.sync="sortHandler" :items-per-page="20" hover
      :footer-props="footerProps" style="white-space: pre-line;" class="elevation-1">
      <template v-slot:[`item.registeredCount`]="{ item }">
        <a style="cursor:pointer; text-decoration: underline; color: #2ea3f0; padding: 6px; font-weight: 600;"
          @click="showRelatedQr(item)">{{
            item.registeredCount }}</a>
      </template>
      <template v-slot:[`item.reportCount`]="{ item }">
        <a style="cursor:pointer; text-decoration: underline; color: #2ea3f0; padding: 6px; font-weight: 600;"
          @click="showRelatedIssues(item)">{{
            item.reportCount }}</a>
      </template>
      <template v-slot:[`item.errorPercentage`]="{ item }">
        {{ item.errorPercentage }}
      </template>
      <template v-slot:[`item.countWaiting`]="{ item }">
        <div style="margin-right: 21px;">
          {{ item.countWaiting }}
        </div>
      </template>
      <template v-slot:[`item.countOngoing`]="{ item }">
        <div style="margin-right: 21px;">
          {{ item.countOngoing }}
        </div>
      </template>
      <template v-slot:[`item.countClosed`]="{ item }">
        <div style="margin-right: 21px;">
          {{ item.countClosed }}
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex'
// import { EventBus } from '@/store/event-bus.js'
import Tooltip from '../../components/HelpTooltip.vue'
import AlertDialog from '../../components/AlertDialog.vue';
import { getFilenameFromContentDisposition } from '../../helpers/filenameFromContentDisposition';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'models',
  components: { Tooltip, AlertDialog },
  data() {
    const dateend = new Date();
    return {
      dateend,
      datestart: new Date(dateend.getTime() - 7 * 24 * 60 * 60 * 1000),
      displaydatestart: this.datestart ? this.datestart.toDateString() : null,
      displaydateend: this.dateend ? this.dateend.toDateString() : null,
      menustart: false,
      menuend: false,
      showNotRegistered: false,

      headers: [
        { title: 'Inventory', align: 'left', key: 'description', width: 200 },
        { title: '', key: '', sortable: false },
        { title: 'Registered on\n(QR Codes)', key: 'registeredCount', width: 150 },
        { title: 'Reported on\n(Issues)', key: 'reportCount', width: 150 },
        { title: 'Error per registered\n(%)', key: 'errorPercentage', width: 150 },
        { title: 'Waiting', key: 'countWaiting', align: "center", width: 100 },
        { title: 'Ongoing', key: 'countOngoing', align: "center", width: 100 },
        { title: 'Closed', key: 'countClosed', align: "center", width: 100 },
      ],
      footerProps: { 'items-per-page-options': [20, 50, 100] },
      statisticsResult: [],

      sortHandler: {},
      sortOptions: {
        sortBy: [],
        sortDesc: [],
      },
      tooltipMessage: [
        "Statistics",
        'This section provides insights into failing inventories. "Error per registered" shows the percentage of added inventories that have failed. Note that individual items are not separated, so it could be one inventory that frequently fails. Click on "Registered on" to see which QR codes have that particular inventory added. Click on "Reported on" to see which issues have that particular inventory added.',
      ],
      loggedInUser: null
    }
  },
  async mounted() {
    const response = await HTTP.get('users/get/logged-in-user');
    this.loggedInUser = response.data;
  },
  computed: {
    ...mapGetters([
      'sort',
      'workspaceid',
      'loading',
      'issuperadministrator',
      'isadministrator',
      'organizationid',
      'organizationitems'
    ]),
    userAllowedToGeneratePDFReports(){
      const currentOrg = this.organizationitems.find(
        (org) => org.id === Number(this.organizationid)
      );
      
      const organizationAllowsPDFReports = currentOrg?.usePdfReports ?? false;
      if (!organizationAllowsPDFReports)
        return false;
      
      return this.issuperadministrator || (this.loggedInUser && this.loggedInUser.canGeneratePDFReports);
    }
  },
  created() {
    this.selectdate();
    this.sortOptions = this.sort.statisticSort || this.sortOptions;
  },
  methods: {
    updatereport(workspaceId) {
      if (Number(workspaceId) === -1) {
        this.statisticsResult = []
        return
      }
      this.$store.dispatch('setLoading', true)
      HTTP.post('/statistics/get/' + this.showNotRegistered + '/' + workspaceId, { datestart: this.datestart, dateend: this.dateend }).then(response => {
        this.statisticsResult = response.data
      }).catch(() => {
        this.statisticsResult = []
      }).finally(() => {
        this.$store.dispatch('setLoading', false)
      })
    },
    selectdate() {
      this.menustart = false
      this.menuend = false
      if (this.datestart !== null) {
        this.displaydatestart = this.datestart.toDateString()
      }
      if (this.dateend !== null) {
        this.displaydateend = this.dateend.toDateString()
      }
      this.updatereport(this.workspaceid)
    },
    clearfilter() {
      this.datestart = null
      this.dateend = null
      this.displaydatestart = null
      this.displaydateend = null
      this.showNotRegistered = false
      this.updatereport(this.workspaceid)
    },
    showRelatedIssues(item) {
      this.$router.push({ name: 'Issue', query: { showClosed: true, inventoryId: `InventoryId(${item.id})` } });
    },
    showRelatedQr(item) {
      this.$router.push({ name: 'QrCode', query: { inventoryId: `InventoryId(${item.id})` } });
    },

    // Ny metod: Generera PDF-rapport med förbättrad felhantering och datumvalidering



   generatePDF() {
    const workspaceId = this.workspaceid;
    
    // 1. Validera att workspace är vald
    if (workspaceId <= 0) {
        this.$store.dispatch('showError', 'Please select a valid workspace first');
        return;
    }
    
    // Hjälpfunktion: Formatera datum som "YYYY-MM-DD" i LOKAL tid
    // Detta förhindrar att datumet backar en dag på grund av UTC-konvertering
    const formatDateLocal = (dateInput) => {
        if (!dateInput) return null;
        const d = new Date(dateInput);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const params = {};
    let startDateFormatted = null;
    let endDateFormatted = null;

    // 2. Villkorlig formatering och lägg till av datumparametrar
    if (this.datestart) {
        startDateFormatted = this.datestart instanceof Date 
            ? formatDateLocal(this.datestart) // Använd hjälpfunktionen
            : this.datestart;
        params.startDate = startDateFormatted;
    }
    
    if (this.dateend) {
        endDateFormatted = this.dateend instanceof Date 
            ? formatDateLocal(this.dateend)   // Använd hjälpfunktionen
            : this.dateend;
        params.endDate = endDateFormatted;
    }

    // 3. Frontend-validering
    if (this.datestart && this.dateend) {
        // Skapa datumobjekt från strängarna för att göra en korrekt jämförelse
        const start = new Date(startDateFormatted);
        const end = new Date(endDateFormatted);
        
        // Kontrollera om Startdatum är efter Slutdatum
        if (start > end) {
            this.$store.dispatch('showError', 'Start date cannot be after end date.');
            return;
        }
    } else if (!this.datestart && this.dateend) {
        this.$store.dispatch('showError', 'Please select a start date.');
        return;
    }
    
    this.$store.dispatch('setLoading', true);


    // 4. Axios-anrop
    HTTP.get(`/api/testpdf/generate-reports-org/${workspaceId}`, {
        params: params,
        responseType: 'blob'
    })
    .then(async response => {
        // Filnedladdning
        const contentDisposition = response.headers['content-disposition'];
        const filename = getFilenameFromContentDisposition(contentDisposition);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        
        link.remove();
        window.URL.revokeObjectURL(url);
        await this.$refs.alertDialog.showDialog('Report generation successful', `File "${filename}" saved locally.`, '$success');
    })
    .catch((error) => {
        console.error("PDF Download Error:", error);
        
        if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const errorText = reader.result;
                    // Försök parsa om det är JSON, annars visa ren text
                    try {
                         const jsonError = JSON.parse(errorText);
                         this.$store.dispatch('showError', jsonError.message || jsonError.title || 'Failed to generate PDF report');
                    } catch {
                         this.$store.dispatch('showError', errorText || 'Failed to generate PDF report');
                    }
                } catch (e) {
                    this.$store.dispatch('showError', 'Failed to generate PDF report');
                }
            };
            reader.readAsText(error.response.data);
        } else {
             this.$store.dispatch('showError', 'Failed to generate PDF report');
        }
    })
    .finally(() => {
        this.$store.dispatch('setLoading', false);
    });
},
  },




  watch: {
    sortHandler: {
      deep: true,
      handler(obj) {
        const objSort = { sortBy: obj.sortBy, sortDesc: obj.sortDesc }
        if (JSON.stringify(objSort) !== JSON.stringify(this.sortOptions)) {
          const newObj = this.sort
          newObj.statisticSort = objSort
          this.$store.dispatch('updateSort', newObj)
        }
      }
    },
    workspaceid(newValue) {
      this.updatereport(newValue);
    },
  },
}
</script>
